// Sessão do Traccar (cookie JSESSIONID) para o rastreamento em tempo real via WebSocket.
// erp.findit.com.br e gprs.findit.com.br são o mesmo site (findit.com.br), então o cookie
// de sessão é compartilhado. O login é best-effort: NUNCA lança — uma falha aqui só pode
// afetar a visualização em tempo real, jamais o login/uso do ERP.
export const TRACCAR_BASE = 'https://gprs.findit.com.br';

const TraccarSessionService = {};

// Estabelece a sessão do Traccar com as mesmas credenciais do login do ERP.
// Retorna true/false; nunca lança.
TraccarSessionService.login = async function (email, password) {
  try {
    const res = await fetch(`${TRACCAR_BASE}/api/session`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      credentials: 'include',
      body: new URLSearchParams({ email, password }).toString(),
    });
    return res.ok;
  } catch (e) {
    return false;
  }
};

// Verifica se há sessão ativa (usado antes de (re)conectar o WebSocket). Nunca lança.
TraccarSessionService.isAtiva = async function () {
  try {
    const res = await fetch(`${TRACCAR_BASE}/api/session`, { credentials: 'include' });
    return res.ok;
  } catch (e) {
    return false;
  }
};

// Carga base da tela de rastreamento: todos os devices (veículos) da conta logada de uma vez.
// NÃO traz posição (lat/lng/velocidade/ignição) — isso vem pelo WebSocket e é casado por device.id.
// Usa o cookie de sessão (credentials:include). Nunca lança: em falha devolve [].
TraccarSessionService.obterDevices = async function () {
  try {
    const res = await fetch(`${TRACCAR_BASE}/api/devices`, {
      credentials: 'include',
      headers: { Accept: 'application/json' },
    });
    if (!res.ok) return [];
    const data = await res.json();
    return Array.isArray(data) ? data : [];
  } catch (e) {
    return [];
  }
};

export default TraccarSessionService;
